import { render, staticRenderFns } from "./HeadlineTitle.vue?vue&type=template&id=702a0e6c&"
import script from "./HeadlineTitle.vue?vue&type=script&lang=ts&"
export * from "./HeadlineTitle.vue?vue&type=script&lang=ts&"
import style0 from "./HeadlineTitle.vue?vue&type=style&index=0&id=702a0e6c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports